module.exports = __webpack_public_path__ + "img/close.3d669e79.svg";